import gql from "graphql-tag";

const DELETE_CASES = gql`
  mutation deleteCases($formId: String!, $applicationIds: [ApplicationIds!]!) {
    deleteCases(formId: $formId, applicationIds: $applicationIds)
  }
`;
const REASSIGN_CASES = gql`
  mutation reassignCases(
    $newUser: UserInput!
    $applicationIds: [ApplicationIds!]!
    $formId: String!
    $tab: String!
  ) {
    reassignCases(
      newUser: $newUser
      applicationIds: $applicationIds
      formId: $formId
      tab: $tab
    )
  }
`;

export { DELETE_CASES, REASSIGN_CASES };
